import React from 'react'
import { ERROR_CODES } from 'api/response'
import { ExtendedError } from 'store/types'
import { Text, Box, Icon } from 'components'

type Props = {
  title?: string
  error?: ExtendedError | null
  message?: string
  align?: 'center' | 'left' | 'right'
}

const InlineError: React.FC<Props> = ({ title, align = 'left', error, message }) => {
  const errCode = Object.keys(ERROR_CODES).find(
    (key: string) => ERROR_CODES[key as keyof typeof ERROR_CODES] === error?.code,
  )
  const body = errCode ? ERROR_CODES[errCode as keyof typeof ERROR_CODES] : error?.message
  return (
    <Box display="flex" justifyContent={align} alignItems="center">
      <Box mr="10px">
        <Icon fontSize={30} icon={['fas', 'exclamation-circle']} color="red" />
      </Box>
      <Box>
        <Text fontSize={16} fontWeight="medium" textAlign={align} color="red">
          {title ?? error?.name ?? 'something_went_wrong_error'}
        </Text>
        <Text textAlign={align} color="red" mt="0.2rem">
          {message ?? body}
        </Text>
      </Box>
    </Box>
  )
}

export default InlineError
